<div class="login-container">
  <app-spinner *ngIf="isSpinner && !hasSentMail" [isSpinning]="isSpinner"></app-spinner>
  <nz-card class="card-body" *ngIf="!isSpinner">
    <div class="login-wrapper">
      <img class="logo" src="/assets/logo/medexam.png" alt="medexam" />

      <div *ngIf="isConfirmMode">
        <h1>{{'setNewPassword' |translate}}</h1>
        <span>{{'setNewPasswordHint' |translate}}</span>
        <form nz-form [formGroup]="passwordForm" (ngSubmit)="submitPasswordForm()">
          <nz-form-item class="input-container">
            <nz-form-control nzErrorTip="{{'passwordInputError' |translate}}">
              <nz-form-label nzRequired for="new-password">{{'newPassword' |translate}}</nz-form-label>
              <nz-input-group [nzSuffix]="newPasswordSuffix">
                <input
                  id="new-password"
                  [type]="passwordVisible ? 'text' : 'password'"
                  nz-input
                  formControlName="password"
                  placeholder="Password"
                />
              </nz-input-group>
              <ng-template #newPasswordSuffix>
                <i
                  nz-icon
                  [nzType]="!passwordVisible ? 'eye-invisible' : 'eye'"
                  (click)="passwordVisible = !passwordVisible"
                ></i>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="input-container">
            <nz-form-control [nzErrorTip]="confirmErrorTpl">
              <nz-form-label nzRequired for="confirm-password">{{'confirmPassword' |translate}}</nz-form-label>
              <nz-input-group [nzSuffix]="confirmPasswordSuffix">
                <input
                  id="confirm-password"
                  [type]="confirmPasswordVisible ? 'text' : 'password'"
                  nz-input
                  formControlName="confirmPassword"
                  placeholder="Password"
                />
              </nz-input-group>
              <ng-template #confirmPasswordSuffix>
                <i
                  nz-icon
                  [nzType]="!confirmPasswordVisible ? 'eye-invisible' : 'eye'"
                  (click)="confirmPasswordVisible = !confirmPasswordVisible"
                ></i>
              </ng-template>
              <ng-template #confirmErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">{{'passwordInputError' |translate}}</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <div class="error-message" *ngIf="passwordForm.hasError('mismatch') && confirmPasswordDirty">
            {{'passwordMismatch' |translate}}
          </div>
          <button class="login-button" nz-button nzType="primary" nzBlock>
            {{'savePassword' |translate}}
          </button>
          <div class="forgot-email-button">
            <a class="forgot-email" [routerLink]="['/login']">{{'returnLogin' |translate}}</a>
          </div>
        </form>
      </div>

      <div *ngIf="!isConfirmMode">
        <div [ngClass]="{ 'display-none': hasSentMail }">
          <h1>{{'passwordRecovery' |translate}}</h1>
          <span>{{'enterEmail' |translate}}</span>
          <form nz-form [formGroup]="emailForm" (ngSubmit)="submitForm()">
            <nz-form-item class="input-container">
              <nz-form-control [nzErrorTip]="emailErrorTpl">
                <nz-form-label nzRequired for="email">{{'email' |translate}}</nz-form-label>
                <nz-input-group nzPrefixIcon="mail">
                  <input [(ngModel)]="email" type="email" nz-input nzRequired formControlName="email"
                    placeholder="mail@exam.com" />
                </nz-input-group>
                <ng-template #emailErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('email')">{{'emailValidError' |translate}}</ng-container>
                  <ng-container *ngIf="control.hasError('required')">{{'emailRequiredError' |translate}}</ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
            <button class="login-button" nz-button nzType="primary" nzBlock>
              {{'send' |translate}}
            </button>
            <div class="forgot-email-button">
              <a class="forgot-email" (click)="forgotEmail()">{{'forgotEmail' |translate}}</a>
            </div>
            <p *ngIf="isForgotEmail" class="contact-message">
              {{'contactMessage1' |translate}}<b>{{'contactEmail' |translate}}</b>{{'contactMessage2' |translate}}
            </p>
          </form>
        </div>
        <div [ngClass]="{ 'display-none': !hasSentMail }">
          <h1>{{'checkEmail' |translate}}</h1>
          <p>{{'checkEmailMessage' |translate}}</p>
          <button class="login-button" nz-button nzType="primary" nzBlock [routerLink]="['/login']">
            {{'returnLogin' |translate}}
          </button>
        </div>
      </div>
    </div>
  </nz-card>
</div>
